<template>
  <div class="d-flex forgeron-filter-container">
    <div class="input-group flex-column pe-2">
      <div class="form-floating filter-input overflow-hidden">
        <input
          :id="'search-' + name"
          v-model="localSubject"
          :style="style"
          :placeholder="label"
          class="form-control filter-input pb-1 ps-2 me-2"
          type="text"
          @keyup.enter="searchModels(route(`${routePrefix}.${resourceType}.search`))"
        />
        <div
          class="position-absolute end-0 top-0 pt-2 pe-3 mt-1 me-1"
          style="cursor: pointer;"
          @click="searchModels(route(`${routePrefix}.${resourceType}.search`))"
        >
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';

export default {
  components: {},
  props: {
    subject: { type: String, default: null },
    name: { type: String, default: 'basic_search' },
    label: { type: String, default: () => 'Suchen...' },
    resourceType: { type: String, default: null },
    redirect: { type: String, default: null },
    style: { type: String, default: () => 'width: 10rem; height: 2.5rem;' },
  },
  setup(props) {
    const localSubject = ref(props.subject);

    const searchModels = (url) => {
      router.post(url, { search: localSubject.value });
    };

    return {
      localSubject,
      searchModels,
    };
  },
};
</script>
